module.exports = __webpack_public_path__ + "static/media/1004034.9d83e36e.png";